<mat-dialog-content>
    <div class="box" style="position: relative">
        <button mat-icon-button class="delete"
                style="position:absolute;top:0px;right:0px;background-color: #ff9b52" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
        <h2 style="margin-top: 0">Foto Upload</h2>
  
        <div style="margin-top:20px;">
            <button style="width: 100%; margin-bottom: 10px;" type="button" mat-raised-button color="primary" (click)="imgFileInput.click()"><mat-icon>add_a_photo</mat-icon> Fotos wählen / aufnehmen</button>
            <input hidden  type="file" #imgFileInput name="file" id="file" class="inputfile inputfile-1" style="display: none"
                   [disabled]="uploading"
                   (change)="startUpload($event)" multiple accept="image/*"/>
        </div>
  
        <div class="text-center" style="width: 100%" *ngIf="uploading">
            <mat-progress-bar style="height: 20px; width: 100%;" mode="determinate"
                              [value]="(((anzahlFertig / anzahlBilder)) / anzahlBilder)"></mat-progress-bar>
            <small>
                {{anzahlFertig}} von {{anzahlBilder}} fertig
            </small>
        </div>
  
  
        <button mat-raised-button
                style="margin-top:20px; width: 100%; margin-bottom: 10px; background-color: #16b921"
                color="primary" (click)="close()"><span *ngIf="!uploading">Bilder Speichern</span><span *ngIf="uploading">Upload Abbrechen</span>
        </button>
  
    </div>
  </mat-dialog-content>
  